import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=38fb961f"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"
import style0 from "./Demo.vue?vue&type=style&index=0&id=38fb961f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports